var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tg-login"},[_c('div',{staticClass:"tg-login--container",staticStyle:{"height":"200px"}},[_c('h1',{staticClass:"tg-login--title"},[_vm._v("Loading...")]),_c('div',{class:_vm.formClass,staticStyle:{"padding":"20px"}},[_c('el-progress',{attrs:{"percentage":_vm.percent,"stroke-width":20}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }